import styled from 'styled-components'

export const TableUserModalContainer = styled.div`
  height: auto;
`

export const TableUserModalData = styled.div`
  position: relative;
  padding: 48px 24px 24px 24px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  border-radius: 4px;
  width: 100%;
`

export const TableUserModalDataItem = styled.div`
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const TableUserModalDataItemCategory = styled.div`
  color: rgba(32, 32, 32, 0.7);
`

export const TableUserModalDataItemText = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
`

export const TableUserModalDataDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(32, 32, 32, 0.1);
  margin: 16px 0;
`

export const TableUserModalDataItemStatus = styled.div`
  display: flex;
  align-items: center;

  > div {
    margin-right: 8px;
  }
`

export const TableUserModalSelectWrapper = styled.div`
  width: 120px;

  > div {
    margin: 0;
  }
`

export const TableUserModalUserTypeChangeWrapper = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin: 0 8px;
  }
`

export const TableUserModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
`

export const TableUSerModalActiveFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const TableUserModalFooterDeclineApproveWrapper = styled.div`
  display: flex;
`

export const TableUserModalFooterButtonWrapper = styled.div`
  margin-left: ${(p) => {
    return p.marginLeft ? '16px' : '0'
  }};
`

export const TableUserModalDataIcon = styled.div`
  position: absolute;
  height: 104px;
  width: 104px;
  border-radius: 50%;
  background: #0aa1f4;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 60px;
  left: 256px;
  z-index: 1000;
  border: 16px solid #ffffff;
  color: #FFFFFF;
`
